module.exports = __webpack_public_path__ + "static/coupon-ru-9a3837b98d1329fee1869fabdce0eae6.png";